import {
  DisciplineModuleClassification,
  IGraduateDisciplineModule
} from 'interfaces/graduate_discipline_module';
import { IAcademicRecord } from 'interfaces/academic_records';
import { IClassroomProfessor } from 'interfaces/professor';
import { getAPI } from 'requests/api';

// GERE6-575: extensão vence estágio, que vence prática.
const classificationPrecedence: DisciplineModuleClassification[] = [
  'extension',
  'internship',
  'practice'
];

export type AcademicHistoryData = IAcademicRecord & {
  professor?: IClassroomProfessor['professor'];
  disciplineModule?: IGraduateDisciplineModule;
};

export const fetchAcademicHistoryData = async (
  courseId: string,
  enrollmentId: string
): Promise<AcademicHistoryData[]> => {
  const [academicRecords, disciplineModulesRes] = await Promise.all([
    getAPI().get(
      `/admin/graduate/academic_records?items=100&page=1&filter[by_course_enrollment_id]=${enrollmentId}`
    ),
    getAPI().get(
      `/admin/graduate/disciplines_modules?items=100&page=1&filter[by_course]=${courseId}`
    )
  ]);

  return mountAcademicHistoryData(
    academicRecords.data,
    disciplineModulesRes.data
  );
};

export const mountAcademicHistoryData = (
  academicRecords: IAcademicRecord[],
  disciplineModules: IGraduateDisciplineModule[]
): AcademicHistoryData[] => {
  return academicRecords.reduce((acc: AcademicHistoryData[], record) => {
    let professor;

    if ('classroom' in record.parent) {
      professor = record.parent.classroom?.classroom_professors?.[0]?.professor;
    }

    const disciplineLinks = disciplineModules.filter(
      dm => dm.discipline.id === record.discipline.id
    );
    const firstModule = disciplineLinks[0];
    // GERE6-540/GERE6-575: mesma regra do PDF. A disciplina recebe a classificação
    // de maior precedência entre os vínculos dela no curso. O tipo
    // (obrigatória/optativa) continua o do primeiro vínculo.
    const classification = classificationPrecedence.find(value =>
      disciplineLinks.some(link => link.classification === value)
    );
    const disciplineModule =
      firstModule && classification
        ? { ...firstModule, classification }
        : firstModule;

    const academicHistoryItem: AcademicHistoryData = {
      ...record,
      professor,
      disciplineModule
    };

    return [...acc, academicHistoryItem];
  }, []);
};
